<template>
  <div class="samples-traceability">
    <div class="p-10 ml-13">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SamplesTraceability'
}
</script>

<style lang="scss" scoped>
@use '@/../static/stylesheets/variables' as *;

.samples-traceability {
  height: $contentContainerHeight;
  padding-top: $mainHeaderHeight;
}
</style>
